import React, { useEffect, useMemo } from 'react';
import { Message as MessageType } from '@/widget/domain/message';
import useConversation from '@/widget/ui/hooks/useConversation';
import useAutoResize from '@/widget/ui/hooks/useAutoResize';
import { groupBy } from 'lodash/lodash';
import Header from '@/widget/ui/components/conversations/Header';
import { parseDate } from '@/lib/datetime/humanizeDate';
import Message from './Message';
import styles from './Conversation.module.scss';
import MessageInput from './MessageInput';
import ContactForm from './ContactForm';

function Conversation() {
  const {
    displayForm,
    messages,
    addMessage,
    delayedMessage,
  } = useConversation();

  const {
    messagesContainer,
    handleMessageInputResize,
    memorizeScrollPosition,
    updateScrollPosition,
  } = useAutoResize();

  const messagesByDate = useMemo(() => {
    if (!messages) { return {}; }
    const messagesByDates = messages.map((message) => (
      { ...message, day: parseDate(message.date) }
    ));
    return groupBy(messagesByDates, 'day');
  }, [messages]);

  useEffect(() => {
    updateScrollPosition();
  }, [messages, updateScrollPosition]);

  return (
    <div className={styles.container}>
      <Header />
      <div
        ref={messagesContainer}
        onScroll={memorizeScrollPosition}
        className={styles.messages}
      >
        {Object.entries(messagesByDate).map((dayMessages: [string, MessageType[]]) => {
          const [date, groupedMessages] = dayMessages;
          return (
            <div key={date}>
              <div className={styles.date}>{date}</div>
              {groupedMessages.map((msg) => (
                <Message
                  key={msg.id}
                  message={msg}
                />
              ))}
            </div>
          );
        })}
      </div>
      {displayForm && <ContactForm />}
      {delayedMessage && (
        <div className={styles.messages}>
          <Message message={delayedMessage} />
        </div>
      )}
      <div className={styles.input}>
        <MessageInput active={!displayForm} handleResize={handleMessageInputResize} addMessage={addMessage} />
      </div>
    </div>
  );
}

export default Conversation;
